import { useFormState } from 'react-hook-form';

import { SaveButton, SaveButtonProps } from '../SaveButton/SaveButton';

export type SaveButtonValidatedProps = SaveButtonProps;

export const SaveButtonValidated = ({ disabled, ...rest }: SaveButtonValidatedProps) => {
  const { isValid } = useFormState();

  return <SaveButton {...rest} disabled={disabled || !isValid} />;
};
